import React from 'react';

import { Order } from '../../../requests/caipirinha-api/interfaces/order.interface';
import PixCode from './pix-code';

interface IListItems {
  description: string;
  children?: any;
  step: string;
}

export const listItems = (order?: Order): Array<IListItems> => [
  {
    step: '1',
    description: 'Copie o código de pagamento no botão abaixo.',
    children: <PixCode order={order} />,
  },
  {
    step: '2',
    description:
      'Abra o app do seu banco ou instituição financeira de sua preferência.',
  },
  {
    step: '3',
    description:
      'Escolha a opção “Pix copia e cola” no app escolhido da sua instituição financeira. Cole o código e autorize o pagamento.',
  },
  {
    step: '4',
    description:
      'Você receberá a confirmação do pagamento no seu email e através dos nosso canais. Simples assim!',
  },
];
